import { render, staticRenderFns } from "./YijingDialog.vue?vue&type=template&id=7ca6e2a4&scoped=true&"
import script from "./YijingDialog.vue?vue&type=script&lang=js&"
export * from "./YijingDialog.vue?vue&type=script&lang=js&"
import style0 from "./YijingDialog.vue?vue&type=style&index=0&id=7ca6e2a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca6e2a4",
  null
  
)

export default component.exports